export interface MrDataTableHeader<T extends string> {
    key: T;
    title: MaybeRefOrGetter<string>;
    fixed?: boolean;
    align?: 'start' | 'center' | 'end';
    width?: number | string;
    minWidth?: number | string;
    columnClass?: string;
    disabled?: MaybeRefOrGetter<boolean>;
}

export interface DataTableGroupings<T extends object> {
    /**
     * Columns that should be merged together.
     * These columns are merged, so that the value of upper rows is expanded to all affecting rows.
     */
    columns: (keyof T)[];
    /**
     * The key that columns should be merged by.
     * It means that rows with the same value of this column are merged in the selected columns.
     */
    by: keyof T | ((row: T) => unknown);
}

export function defineHeader<T extends string>(
    headerDefinitions: MrDataTableHeader<T>[]
): MrDataTableHeader<T>[] {
    return headerDefinitions;
}
